<template>
  <div>
    <main-layout>
      <v-container>
        <div
          class="mt-4"
          style="background-color: #fdf5f3; border-radius: 10px; height: 700px; display: flex"
        >
          <v-layout>
            <v-flex xs12 sm7 class="d-flex justify-center align-center">
              <v-img
                src="/static/img/assets/img-check-in-check-out.png"
                max-width="400px"
                width="100%"
                contain
              ></v-img>
            </v-flex>
            <v-flex xs12 sm5 style="display: flex; justify-content: center; align-items: center">
              <div class="text-xs-center black--text" style="font-size: 20px">
                <div style="display: flex; justify-content: center" class="font-weight-bold mb-4">
                  <span style="color: #002d63" class="mr-1">Welcome to NTPLC</span>
                </div>

                <v-layout row wrap>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="isCheckedIn"
                      class="ticket2profilebtn"
                      color="primary"
                      large
                      @click="onCheckinCheckout('check-in')"
                    >
                      <div>
                        <div>
                          <img
                            :style="isCheckedIn ? '   filter: opacity(0.5)' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/icon-login-white.png"
                          />
                        </div>
                        <div :class="isCheckedIn ? 'grey--text' : 'white--text'">Check-in</div>
                      </div>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :loading="saveloading"
                      :disabled="!isCheckedIn"
                      class="ticket2profilebtn"
                      color="primary"
                      :class="!isCheckedIn ? 'grey--text' : 'white--text'"
                      large
                      @click="onCheckinCheckout('check-out')"
                    >
                      <div>
                        <div>
                          <img
                            :style="!isCheckedIn ? 'filter: opacity(0.5)' : ''"
                            width="30px"
                            src="/static/img/assets/ticket2/icon-logout-white.png"
                          />
                        </div>
                        <div :class="!isCheckedIn ? 'grey--text' : 'white--text'">Check-out</div>
                      </div>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ticketApi from '@/api/ticket'

export default {
  data() {
    return {
      logloading: false,
      saveloading: false,
      logData: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    isCheckedIn() {
      if (
        this.logData &&
        this.logData.length > 0 &&
        this.logData[0].check_in_timestamp &&
        this.logData[0].check_out_timestamp === null
      ) {
        return true
      } else return false
    }
  },
  mounted() {
    this.handleGetAdminCheckInCheckOutLog()
  },
  methods: {
    async onCheckinCheckout(actions) {
      const vm = this
      try {
        const data = {
          admin_id: vm.$store.state.userid
        }

        const title = `คุณต้องการ ${actions} ?`
        vm.$swal
          .fire({
            text: title,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            showCancelButton: true
          })
          .then(async (result) => {
            if (result.value) {
              vm.saveloading = true
              let response = null
              if (actions === 'check-in') {
                response = await vm.adminCheckIn(data)
              } else if (actions === 'check-out') {
                response = await vm.adminCheckOut(data)
              }

              vm.saveloading = false

              if (response && response.status === 200) {
                await vm.handleGetAdminCheckInCheckOutLog()
                vm.saveloading = false
                vm.$swal.fire({
                  text: actions + ' สำเร็จ',
                  type: 'success'
                })
              }
            }
          })
      } catch (error) {
        console.error(error)
      }
    },
    async handleGetAdminCheckInCheckOutLog() {
      const vm = this
      try {
        const response = await vm.getAdminCheckInCheckOut()

        if (response && response.status === 200) {
          const responseData = response.data.data
          vm.logData = responseData
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getAdminCheckInCheckOut() {
      const vm = this
      try {
        const params = {
          admin_id: vm.$store.state.userid,
          page_id: vm.selectedBot.pageid,
          limit: 10,
          offset: 0
        }

        const response = await ticketApi.getAdminCheckInCheckOut({ params })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async adminCheckIn(payload) {
      try {
        const response = await ticketApi.postAdminCheckIn({ data: payload })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async adminCheckOut(payload) {
      try {
        const response = await ticketApi.postAdminCheckOut({ data: payload })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss">
.ticket2profilebtn {
  border-radius: 15px !important;
  width: 100px !important;
  height: 94px !important;
  font-size: 14px !important;
  text-transform: none !important;

  color: grey !important;

  line-height: 21px !important;
  margin-top: 10px !important;
  //   display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/CheckInCheckOut/index.vue